export default __webpack_public_path__ + "img/InterVariable-Italic_01dcbad.woff2";